import CheckUserAccess from 'src/finsight/ui/common/components/CheckUserAccess';
import { RestrictedAccessExplanation } from '@/finsight/ui/common/components/Explanations';
import { useDealTooltipContext } from '@/finsight/application/Deal/DealTooltipContext';
import { PRICING_EXPLAINATION_TITLE, PRICING_EXPLAINATION_DESCRIPTION } from '@/finsight/ui/components/deals/constants';
import type IDeal from '@/finsight/domain/vo/IDeal';
import { useDealAccess } from '@/finsight/ui/components/deals/useDealAccess';

export const RestrictedAccessRowWrapper = ({ children, row }: { children: React.ReactNode, row: IDeal }) => {
    const { popperModifiers, dealTooltipOpened, setDealTooltipOpened } = useDealTooltipContext();
    const { userAccessChecks } = useDealAccess();

    return (
      <CheckUserAccess
        checks={ userAccessChecks }
        fallback={ (
          <RestrictedAccessExplanation
            title={ PRICING_EXPLAINATION_TITLE }
            description={ PRICING_EXPLAINATION_DESCRIPTION }
            isOpen={ dealTooltipOpened === row.id }
            closeTooltip={ () => setDealTooltipOpened(null) }
            popperModifiers={ popperModifiers }
          >
            <>{ children }</>
          </RestrictedAccessExplanation>
        ) }
      >
        { children }
      </CheckUserAccess>
    );
};
